const Component = () => import('./ShoppingPlan');

export { Component };
